module.exports = __webpack_public_path__ + "img/hong_kong_2015.100ff0f5.png";